import { render, staticRenderFns } from "./RemunerationAgents.vue?vue&type=template&id=122e01c5&"
import script from "./RemunerationAgents.vue?vue&type=script&lang=js&"
export * from "./RemunerationAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports